/** Internal staff authenticate exclusively through Google Workspace. */
import { useState } from "react"
import { withTranslation, WithTranslation } from "react-i18next"
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth"
import { firebaseAppAuth } from "@/App"
import Button from "@/components/button"
import Card from "@/components/card"
import NavLogin from "@/nav/nav.login"
import LoginIconWidget from "@/widgets/login-icon.widget"
import Space from "@/components/space"
import Link from "@/components/link"
import LoginModal from "@/modals/login.modal"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

function LoginSupervisor({ t }: WithTranslation) {
  const navigate = useNavigate()
  const [busy, setBusy] = useState(false)
  const [identity, setIdentity] = useState<{ email: string; firebaseToken: string } | null>(null)

  async function login() {
    if (busy) return
    setBusy(true)
    try {
      const provider = new GoogleAuthProvider()
      provider.setCustomParameters({ prompt: "select_account" })
      // Start the popup directly from the click, preserving the browser user gesture.
      const result = await signInWithPopup(firebaseAppAuth, provider)
      if (!result.user.email) throw new Error("sso_identity_mismatch")
      setIdentity({ email: result.user.email, firebaseToken: await result.user.getIdToken(true) })
    } catch (error: any) {
      toast(t(error.code ? "firebase_" + error.code : error.message), { type: "error" })
      setBusy(false)
    }
  }

  return <NavLogin>
    {identity && <LoginModal authLevel={2} email={identity.email} isSupervisor toSupervisor
      workspaceIdentity={identity} onClose={() => { setIdentity(null); setBusy(false) }} />}
    <LoginIconWidget />
    <div className="flex">
      <Space />
      <div>
        <Card title={<span style={{ width: "100%", textAlign: "center" }}>{t("sso_supervisor_title")}</span>}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={require("@/assets/sherlock.png")} alt="" width={120} />
          </div>
          <div className="height-20" />
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button type="button" className="secondary" isWithBorder isFullWidth disabled={busy} isLoading={busy} onClick={login}>
              <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 12 }}>
                <img src={require("@/assets/google.png")} alt="" width={20} height={20} />
                <span>{t(busy ? "sso_connecting" : "sso_workspace_button")}</span>
              </span>
            </Button>
          </div>
        </Card>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Link isWhite onClick={() => navigate("/login/home")}>{t("supervisor_connect_account")}</Link>
        </div>
      </div>
      <Space />
    </div>
    <Space />
  </NavLogin>
}
export default withTranslation()(LoginSupervisor)
